export class Photo {
    constructor(
        public src: string,
        public alt: string
    ){}
}